var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Plugin, ModelRange, RevisionTracker, Notification } from 'shared/domains/pleditor@next';
export class ImportWordRTC extends Plugin {
    static get pluginName() {
        return 'ImportWordRTC';
    }
    init() {
        this.editor.on('ready', () => this.setupImportListeners(), { priority: 'low' });
    }
    setupImportListeners() {
        const importWordCommand = this.editor.commands.get('importWord');
        if (importWordCommand) {
            importWordCommand.on('dataInsert', () => this.beforeImport(), { priority: 'highest' });
            importWordCommand.on('dataInsert', () => this.afterImport(), { priority: 'lowest' });
        }
    }
    beforeImport() {
        return __awaiter(this, void 0, void 0, function* () {
            const { editor } = this;
            const root = editor.model.document.getRoot();
            if (!root) {
                return;
            }
            const revisionTrackerPlugin = editor.plugins.get(RevisionTracker);
            const { currentRevision } = revisionTrackerPlugin;
            const { version } = editor.model.document;
            // Capture version containing unsaved work
            const preImportVersion = currentRevision && version > currentRevision.fromVersion ? version : null;
            editor.model.change((writer) => {
                const range = writer.createRangeIn(root);
                const startRange = editor.model.schema.getNearestSelectionRange(range.start);
                const endRange = editor.model.schema.getNearestSelectionRange(range.end);
                if (!startRange || !endRange) {
                    return;
                }
                writer.setSelection(new ModelRange(startRange.start, endRange.end));
                writer.model.deleteContent(writer.model.document.selection);
            });
            yield revisionTrackerPlugin.update();
            if (preImportVersion !== null) {
                yield revisionTrackerPlugin.saveRevision({}, preImportVersion);
            }
            yield revisionTrackerPlugin.saveRevision({
                name: t({
                    comment: 'Pleditor revision history version name after document import',
                    message: 'Document import',
                }),
            });
        });
    }
    afterImport() {
        const notificationPlugin = this.editor.plugins.get(Notification);
        notificationPlugin.showSuccess(t({
            comment: 'Pleditor - Import document success message',
            message: 'Successfully imported document',
        }));
    }
}
